module.exports = __webpack_public_path__ + "static/media/scale.c81235d0.svg";